import React, { Fragment, useContext, useState, useEffect } from "react";
import { Link, useHistory } from 'react-router-dom';
import Button from '../../lib/ui/buttons/Button';
import 'react-phone-number-input/style.css';
import { LangCtx } from "../../lib/context";
import "../../layouts/Layouts.css";
import '../../lib/ui/inputs/InputStyles.css';
import { forgotPassword } from "../../actions/users";
import { toast } from "react-toastify";
import InputField from '../../lib/ui/inputs/Input';
import { Auth } from "aws-amplify";
import { validateEmail, validateIntlPhone } from "../../lib/validation";
import LogoBranding from '../../lib/ui/logoBranding/LogoBranding';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import { getSubdomain } from "../../lib/domain";
// const psl = require("psl");


const ForgotPassword = () => {
    const history = useHistory();
    const { l } = useContext(LangCtx);
    const [countryCode, setCountryCode] = useState(null);
    const [userName, setUserName] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    // const _domain = psl.parse(window.location.hostname);
    const _domain = getSubdomain(window.location.hostname);


    // const handleun = (e) => {
    //     let _val = e.target.value.replace(/ /g, "");
    //     let val = /^\d+$/.test(_val) ? "+91" + _val : _val;
    //     setUserName(val);
    // }

    const validate = () => {
        if (userName === '' || userName == null) {
            setErrorMsg(l.pls_enter_phone)
            return false;
        }
        // else if (!isValidPhoneNumber(userName)) {
        //     setErrorMsg(l.pls_check_phone)
        //     return false;
        // }

        return true;
    }

    const handleForgotPwd = (e) => {
        e.preventDefault();
        if (validate()) {

            // const phoneNumber = parsePhoneNumber(userName)
            // const countrycode = phoneNumber.countryCallingCode;
            // const number = phoneNumber.nationalNumber;
            try {
                if (process.env.REACT_APP_isOffline === "true") {

                    let body = {
                        phone: userName.replaceAll(' ', '')
                    }
                    forgotPassword(body)
                        .then(res => {
                            if (res.userId) {
                                toast.success(res.data, {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                setErrorMsg('');
                                history.push('/reset-password?username=' + encodeURIComponent(userName.replaceAll(' ', '')) + '&userId=' + res.userId);
                            }
                            else {
                                setErrorMsg(l.went_worng_pls_try_again);
                            }
                        })
                        .catch(err => {
                            let msg = err && err.message ? err.message : l.went_worng_pls_try_again;
                            setErrorMsg(msg);
                        });
                } else {
                    if (validateEmail(userName) || validateIntlPhone(userName)) {
                        Auth.forgotPassword(userName.replaceAll(' ', '').toLowerCase())
                            .then(data => {
                                toast.success(l.OTP_sent_your_registered_username , {
                                    position: toast.POSITION.TOP_RIGHT
                                })
                                setErrorMsg('');
                                history.push('/reset-password?username=' + encodeURIComponent(userName.replaceAll(' ', '').toLowerCase()))
                            })
                            .catch(err => {
                                console.log("err", err);
                                let msg = err && err.message ? err.message : l.went_worng_pls_try_again;
                                setErrorMsg(msg);
                            });
                    } else {
                        setErrorMsg(l.pls_valid_mail);
                    }

                }
            } catch (err) {
                let msg = err && err.message ? err.message : l.went_worng_pls_try_again;
                setErrorMsg(msg);
            }
        }
    }

    const handleUsername = (e) => {
        let val = e.target.value;
        if (/[a-zA-Z]/.test(val)) {
            let uname = val.includes(countryCode) ? val.replace(countryCode, '') : val;
            setUserName(uname);

        } else {
            let uname = val.includes(countryCode) || val.length < 4 ? val : `${countryCode}${val}`;
            setUserName(uname);
        }
    }

    const getCountryCode = async () => {
        try {
            const countryCode = await fetch('https://ipapi.co/json');
            const res = await countryCode.json();
            setCountryCode(res?.country_calling_code ? res?.country_calling_code : "+91")
        } catch (err) {
            setCountryCode("+91");
        }
    }

    useEffect(() => {
        getCountryCode();
    }, []);

    return <Fragment>
        <div className="coverContainer">
            <div className="outSideContainer">
                <div className="colCredential overRightjtcCenter mrgnVAuto">
                    <div className="topRow pdngHMD">
                        <div className="langBlock">
                            {_domain?.subdomain === process.env.REACT_APP_defaultdomian && <div className="helpBtn DeskDisplayorNot">
                                <a className='logintollfree flexInline alignCntr' href="https://help.instavc.com/inclinic" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help_center}
                                </a>
                            </div>}
                            {/* <div className="helpBtn mobDisplayorNot">
                                <a className='logintollfree flexInline alignCntr' href="https://help.instavc.com/inclinic" target="_blank">
                                    <PlayCircleFilledWhiteIcon className='callIcon' fontSize='small' />{l.help}
                                </a>
                            </div> */}
                        </div>
                    </div>
                    <div className="bodyRow fullHightJC">
                        <div className="brandingBlock">
                            <LogoBranding />
                        </div>
                        <div className="crdRowBlock justifyCenter">
                            <h2 className="headingTxt">{l.forgot_password}</h2>
                        </div>
                        <div className="crdRowBlock alignCenter justifyCenter">
                            <span className="pTxt txtCenter pdngHSM">{l.forgot_pwd_msg}</span>
                        </div>
                        <div className="crdFormBlock">
                            {errorMsg && errorMsg !== "" && <div className="errorBox">
                                <small className="errorTxt">{errorMsg}</small>
                            </div>
                            }
                            <form id="forgotform" onSubmit={handleForgotPwd}>
                                <div className="colBlock">

                                    <div className="inputBox colBlock nopdng">


                                        <InputField
                                            placeholder={l.enter_ur_usename}
                                            type="text"
                                            maxLength="30"
                                            onChange={handleUsername}
                                            value={userName.replaceAll(' ', '')}
                                        />
                                    </div>

                                    <div className="crdBtnContainer">
                                        <Button onClick={handleForgotPwd}
                                            label={l.submit}
                                            type='primary'
                                            size='md'
                                            buttonType="submit"
                                            fullWidth="fullWidth"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="footerRow">
                            <div className="rowSpaceBtwn">
                                {/* <p className="pTxt">{l.backtologin}</p> */}
                                <Link to="/" className="fullTxtLink">
                                    {/* <img src="/images/icons/arrow.png" alt="icon" /> */}
                                    <span>{l.backtologin}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
}

export default ForgotPassword;
